import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';

export const GeneralModalWrapper = styled(Modal)`
  .general_modal {
    text-align: center;
    padding: 20px;
    overflow: hidden;
    

    .general_message {
      color: #666;
      font-size: 18px;
      line-height: 30px;
      font-weight: 600;
    }

  }
`;



// WEBPACK FOOTER //
// ./src/components/GeneralModal/components/styles.js